import { render } from "./Wearable.vue?vue&type=template&id=0f61fb1f&scoped=true&ts=true"
import script from "./Wearable.vue?vue&type=script&lang=ts"
export * from "./Wearable.vue?vue&type=script&lang=ts"

import "./Wearable.vue?vue&type=style&index=0&id=0f61fb1f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f61fb1f"]])

export default __exports__